import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HomologacionproductoModule } from '../modelo/homologacionproducto/homologacionproducto.module';

@Injectable({
  providedIn: 'root'
})
export class HomologacionService {

  constructor(private http: HttpClient) { }

  

   registrar(lista :HomologacionproductoModule[])
  {

    return this.http.put(environment.apiUrl+"actualizarHomologacionProducto/",lista); 
   }


   eliminar(entidad:HomologacionproductoModule)
   {
 
     return this.http.put(environment.apiUrl+"eliminarHomologacionProducto/",entidad); 
    }
 

  listar()
  {

    return this.http.get(environment.apiUrl+"listarHomologacionProducto/"); 
   }


   listarProductoVenta()
   {
 
     return this.http.get(environment.apiUrlFlp+"listaProductoVenta/"); 
    }
  
}
